import { IntegrationType, IntegrationActions, Types } from "../../interfaces/interface.reducer";

export const integrationReducer = (state: IntegrationType, action: IntegrationActions) => {
	switch (action.type) {
		case Types.GetRules:
			return { ...state, rules: action.payload.rules };
		default:
			return state;
	}
};